import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { AccountOutput, entityName } from '@qtek/shared/models';

import { HttpEntityManager } from './../http-entity-manager';

@Injectable({
  providedIn: 'root',
})
export class CompanyService extends HttpEntityManager<AccountOutput, any> {
  protected http = inject(HttpClient);

  entityName: entityName = 'acn';

  constructor() {
    super();
  }

  updateCompany(additionalPayload: any = {}, payload: any = {}) {
    return super.put(payload, null, additionalPayload);
  }
}
